import { createApiConfig, createApiConfigForFiles } from "./config";

import {ACCOUNTS_API_URL, FILE_UPLOAD_URL} from "./routes"

const apiConfig = createApiConfig();

const apiConfigForFiles = createApiConfigForFiles();
// GET Account List

export const addAccount = (inputs) => apiConfig.post(ACCOUNTS_API_URL,inputs);

export const getAccounts = () => apiConfig.get(ACCOUNTS_API_URL);

export const exportAccounts = () => apiConfig.post(`${ACCOUNTS_API_URL}/export`, null, { responseType: 'blob' });

export const getAccountSummary = () => apiConfig.get(`${ACCOUNTS_API_URL}-summary`);

export const updateAccount = (id, inputs) => apiConfig.put(`${ACCOUNTS_API_URL}/${id}`, inputs);

export const deleteAccount = (id) => apiConfig.delete(`${ACCOUNTS_API_URL}/${id}`);

export const updateAccountStatus = (id, inputs) => apiConfig.put(`${ACCOUNTS_API_URL}/${id}/status`, inputs);

export const uploadFile = (file) => {
    return apiConfigForFiles.post(FILE_UPLOAD_URL, file);
}